import { isBrowser } from './isBrowser';

// 生成随机数
const guid = () => {
  function S4() {
    // eslint-disable-next-line no-bitwise
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return `${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`;
};

// 创建iframe
export const frameScheme = (url) => {
  if (isBrowser) {
    const iframeEle = document.createElement('iframe');
    iframeEle.style.display = 'none';
    const uuid = guid();
    iframeEle.id = uuid;
    iframeEle.src = url;
    document.body.appendChild(iframeEle);
    iframeEle.onload = function () {};
    iframeEle.onerror = function () {};
    setTimeout(() => {
      document.body.removeChild(iframeEle);
    }, 500);
  }
};
